import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-semibold text-gray-900 mb-6 leading-tight">
              About ETAN LLC
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Professional marketing and consulting services for international business growth.
            </p>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              ETAN LLC is a marketing and consulting company based in Dubai, United Arab Emirates. Founded in 2025, the company focuses on supporting businesses in the European Union and international markets with professional marketing strategies and business advisory services.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our approach is based on clarity, structure, and measurable outcomes. We work closely with clients to understand their positioning, identify growth opportunities, and implement effective strategies aligned with their business objectives.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              ETAN LLC operates with a strong emphasis on professionalism, confidentiality, and long-term client relationships.
            </p>
          </div>
        </div>
      </section>

      {/* Core Principles */}
      <section className="py-24 bg-gray-50 border-y border-gray-200">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="mb-16">
            <h2 className="text-4xl font-semibold text-gray-900 mb-4">
              Our Approach
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-12 max-w-5xl">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Clarity
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Clear communication and transparent processes in all client engagements.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Structure
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Systematic methodology and organized project execution for reliable outcomes.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Results
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Focus on measurable performance indicators and tangible business impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Details */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 gap-16 max-w-5xl">
            <div>
              <h2 className="text-3xl font-semibold text-gray-900 mb-6">
                Company Information
              </h2>
              <div className="space-y-4">
                <div>
                  <div className="text-sm font-medium text-gray-500 mb-1">Established</div>
                  <div className="text-lg text-gray-900">2025</div>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500 mb-1">Location</div>
                  <div className="text-lg text-gray-900">Dubai, United Arab Emirates</div>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500 mb-1">Contact</div>
                  <div className="text-lg text-gray-900">info@etanllc.com</div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-semibold text-gray-900 mb-6">
                Client Focus
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                ETAN LLC works primarily with clients in the European Union and international markets.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our services are designed to address the specific requirements of cross-border business operations and diverse regulatory frameworks.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-blue-900">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <h2 className="text-4xl font-semibold text-white mb-6">
              Work With Us
            </h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Contact ETAN LLC to discuss how we can support your business development and marketing objectives.
            </p>
            <Link to="/contact">
              <Button 
                className="bg-white hover:bg-gray-100 text-blue-900 px-8 h-12 rounded-sm font-medium transition-colors duration-200"
              >
                Request Consultation
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;